import { Stack, styled } from "@mui/material";

const StyledContainer = styled(Stack)(({ theme }) => ({
  height: "calc(((1 - var(--template-frame-height, 0)) * 100dvh) - 0px)",
  minHeight: "100%",
  padding: theme.spacing(0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(0),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundColor: "#f4f4f5",
    padding: {
      sm: 0,
    },
  },
}));

export default StyledContainer;